import { Button } from './Button';

export interface EmptyAction {
  label: string;
  onClick: () => void;
}

/**
 * What a list says when it has nothing to show: the cause, and at most one thing to do about it (UX audit #11,
 * D8): "Clear filters" when filters hide the rows, "New …" when nothing exists yet and the person may create.
 * A failed load is not empty: pages show `ErrorState` with Retry instead.
 */
export function EmptyState({ message, action }: { message: string; action?: EmptyAction | null | false }) {
  return (
    <span className="fs-empty">
      <span>{message}</span>
      {action && (
        <Button variant="secondary" size="sm" onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </span>
  );
}
